export const CART_SET = 'CART_SET'
export const USER_SET = 'USER_SET'
export const GLOBAL_SET = 'GLOBAL_SET'
export const ORDER_SET = 'ORDER_SET'



// WEBPACK FOOTER //
// ./vue/checkout/store/mutation-types.js